import { render, staticRenderFns } from "./Honors.vue?vue&type=template&id=666e037e&scoped=true&"
import script from "./Honors.vue?vue&type=script&lang=js&"
export * from "./Honors.vue?vue&type=script&lang=js&"
import style0 from "./Honors.vue?vue&type=style&index=0&id=666e037e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666e037e",
  null
  
)

export default component.exports